import { Injectable } from '@angular/core';
import { DocumentMoveAuthTableConfig } from '@app/documents/models/document-move-auth-table-config.model';
import { ICoreAuthorizationDTO, ICoreMemberDTO, IDocumentResponseDTO } from '@core/model';
import { TableColumn } from '@mynexus/mynexus-ui-lib';
import { AuthorizationDMEPOSService } from './authorization.service';
import { Observable, forkJoin } from 'rxjs';
import { MemberDmePosService } from './member.service';

@Injectable({
  providedIn: 'root',
})
export class DocumentsMoveDmePosService {
  constructor(
    private autorizationDMEPOSService: AuthorizationDMEPOSService,
    private memberDMEPOSService: MemberDmePosService,
  ) {}

  getAuthorizationTableConfig(): TableColumn[] {
    return [
      new TableColumn('Authorization Number', 'authorizationNumber', '10rem'),
      new TableColumn('MemberID', 'memberId', '9rem'),
      new TableColumn('Member Name', 'memberName', '9rem'),
      new TableColumn('Effective From', 'effectiveFromDate', '9rem'),
      new TableColumn('Effective To', 'effectiveToDate', '9rem'),
      new TableColumn('Auth Status', 'authorizationStatus', '8rem'),
      new TableColumn('Total Approved Units', 'totalApprovedUnits', '8rem'),
      new TableColumn('Created On', 'createdOn', '8rem'),
      new TableColumn('Created By', 'createdBy', '8rem')
    ];
  }

  mapAuthorizationTableData(authorizationDto: ICoreAuthorizationDTO[], memberDto: ICoreMemberDTO): DocumentMoveAuthTableConfig[] {
    return authorizationDto.map(x => {
      const totalApprovedUnits = x.streamData['cases']
        .map((c: object[]) => c['productLines'])
        .flat()
        .reduce((sum: number, p: object) => sum + p['unitsApproved'], 0);

      return {
        authorizationNumber: x.authorizationNumber,
        memberId: memberDto?.subscriberNumber,
        memberName: memberDto ? `${memberDto.firstName} ${memberDto.lastName}` : '',
        effectiveFromDate: x.effectiveFromDate,
        effectiveToDate: x.effectiveToDate,
        authorizationStatus: x.authorizationStatus,
        totalApprovedUnits: totalApprovedUnits,
        createdOn: x.createdOn,
        createdBy: x.createdBy,
      }
    });
  }

  getMoveDocumentData(tenantId: string, newAuthorizationNumber: string): Observable<[ICoreAuthorizationDTO, ICoreMemberDTO]> {
    return forkJoin([
      this.autorizationDMEPOSService.getCoreAuthorization(tenantId, newAuthorizationNumber),
      this.memberDMEPOSService.getMemberByAuthNumber(tenantId, newAuthorizationNumber)
    ]);
  }

  filterDocuments(documents: IDocumentResponseDTO[]): IDocumentResponseDTO[] {
    return documents;
  }
}
